import { createFileRoute } from "@tanstack/react-router";
import { LoginPage } from "#login/pages/login-page/login-page.tsx";

export const Route = createFileRoute("/")({
  component: LoginPage,
});
